import { create } from 'zustand';
import { isFunction } from 'lodash';
import { MutatingAuthGraphUser, MutatingRedditUser } from 'wb-reddit/app/routes/users/mutator/utils';
import { CreateUserAccountLevel } from 'wb-reddit/graphql/generated';
import { UserAccountLevel } from 'wb-spotify/graphql/authgraph/generated';

type RedditUserMutationStorage = {
	mutationUser: MutatingRedditUser | MutatingAuthGraphUser | undefined
	setMutationUser: (user: undefined | MutatingRedditUser | MutatingAuthGraphUser | ((curr: MutatingRedditUser | MutatingAuthGraphUser | undefined) => MutatingRedditUser | MutatingAuthGraphUser | undefined)) => void
};

export const newUserData: MutatingRedditUser = {
	userId:                '',
	userName:              '',
	userSurname:           '',
	userEmail:             '',
	userEmailConfirmation: '',
	userAccountLevel:      CreateUserAccountLevel.User,
	userProfilePicture:    undefined,
	userGroups:            [],
};

export const newAuthGraphUserData: MutatingAuthGraphUser = {
	userId:                   '',
	userName:                 '',
	userSurname:              '',
	userEmail:                '',
	userEmailConfirmation:    '',
	userAccountLevel:         UserAccountLevel.User,
	userPassword:             '',
	userPasswordConfirmation: '',
};

const defaultRedditUserMutationStorage = {
	mutationUser: undefined,
};

// TODO check mutation function, executes multiple times when open edit page
const useRedditUserMutationStorage = create<RedditUserMutationStorage>((set) => ({
	...defaultRedditUserMutationStorage,
	setMutationUser: user => {
		set(curr => ({
			mutationUser: isFunction(user) ? user(curr.mutationUser) : user,
		}));
	},
}));

export default useRedditUserMutationStorage;
